import React from "react";
import { Flex, NavLink, Text, useMantineTheme } from "@mantine/core";
import { Location, Sms } from "iconsax-react";
import { useMediaQuery } from "@mantine/hooks";
import { client_selected } from "../../client";
import { useTranslation } from "react-i18next";

const ContactFooter = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isLargerThan400 = useMediaQuery("(min-width: 400px)");
  const address = client_selected.address;
  const contacts = client_selected.contacts;
  const email = client_selected.email;

  const Dot = () => {
    return (
      <Flex
        w={6}
        h={6}
        bg="basic.0"
        sx={{ borderRadius: "100%", content: "''" }}
      />
    );
  };

  return (
    <Flex
      id="contactFooter"
      w="100%"
      align="start"
      maw={{ base: 560, 991: 320, 1152: 400 }}
      direction="column"
      gap={12}
      sx={{
        fontFamily: "Barlow",
        fontWeight: 500,
        lineHeight: "28px",
        whiteSpace: "nowrap",
        color: theme.colors.basic[0],
      }}
    >
      {!!address ? (
        <Flex align="center" gap={16}>
          <Location size={24} style={{ minWidth: "24px" }} />
          <Flex
            sx={{ fontFamily: "Barlow", fontWeight: 500, lineHeight: "28px" }}
            columnGap={12}
            align="center"
            wrap={"wrap"}
            miw={180}
          >
            <Flex align="center" gap={12}>
              {`${address?.street}, ${address?.number}`}
              <Dot />
            </Flex>
            <Flex align="center" gap={12}>
              {address?.complement}
              <Dot />
            </Flex>
            {!!address?.neighborhood ? (
              <Flex align="center" gap={12}>
                {address?.neighborhood}
                <Dot />
              </Flex>
            ) : null}
            {!!address?.zipcode ? (
              <Flex align="center" gap={12}>
                {address?.zipcode}
                <Dot />
              </Flex>
            ) : null}

            {`${address?.city}/${address?.state}`}
          </Flex>
        </Flex>
      ) : null}
      {!!contacts ? (
        <>
          {contacts.map((contact, index) => (
            <Flex direction={"column"} key={index} w="100%">
              <Text fz="16px" style={{ whiteSpace: "break-spaces" }}>
                {t(contact.name)}
              </Text>
              <NavLink
                label={contact.contactText}
                c="#fff"
                component="a"
                href={contact.contact}
                target="_blank"
                p="0"
                sx={{
                  span: {
                    fontSize: "20px",
                    whiteSpace: isLargerThan400 ? "nowrap" : "pre-wrap",
                    wordBreak: isLargerThan400 ? "unset" : "break-all",
                  },
                }}
              />
              {!!contact.description ? (
                <Text fz="12px">{t(contact.description)}</Text>
              ) : null}
            </Flex>
          ))}
        </>
      ) : !!email ? (
        <Flex
          gap={24}
          direction={{ base: "row", 796: "column", 1260: "row" }}
          wrap={{ base: "wrap" }}
          justify={{ base: "start", 670: "start" }}
        >
          <NavLink
            label={t(email.email)}
            c="#fff"
            icon={<Sms size={24} />}
            component="a"
            href={email.link}
            target="_blank"
            p="0"
            sx={{
              span: {
                marginRight: "16px",
                whiteSpace: isLargerThan400 ? "nowrap" : "pre-wrap",
                wordBreak: isLargerThan400 ? "unset" : "break-all",
              },
            }}
          />
        </Flex>
      ) : null}
    </Flex>
  );
};

export default ContactFooter;
